import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useId, useState } from 'react';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { MoreHorizIcon } from '../icons.js';
import { IconButton } from './button.js';
/**
 * The "more actions" menu (§ a11y: destructive actions live in an overflow menu, are
 * confirmed, and are never the row's only click target). The trigger is an icon button
 * with a real name; the menu is keyboard operable through MUI's Menu.
 */
export function OverflowMenu({ items, label = 'More actions', size = 'small', }) {
    const [anchor, setAnchor] = useState(null);
    const menuId = useId();
    const open = Boolean(anchor);
    const primary = items.filter((i) => !i.destructive);
    const destructive = items.filter((i) => i.destructive);
    const renderItem = (item) => (_jsxs(MenuItem, { disabled: item.disabled, onClick: () => {
            setAnchor(null);
            item.onSelect();
        }, sx: item.destructive ? { color: 'error.main' } : undefined, children: [item.icon && _jsx(ListItemIcon, { sx: { '& svg': { fontSize: 18 } }, children: item.icon }), item.label] }, item.id));
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { label: label, size: size, "aria-haspopup": "menu", "aria-expanded": open, "aria-controls": open ? menuId : undefined, onClick: (e) => setAnchor(e.currentTarget), children: _jsx(MoreHorizIcon, { fontSize: "small" }) }), _jsxs(Menu, { id: menuId, anchorEl: anchor, open: open, onClose: () => setAnchor(null), anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, slotProps: { list: { 'aria-label': label } }, children: [primary.map(renderItem), primary.length > 0 && destructive.length > 0 && _jsx(Divider, {}), destructive.map(renderItem)] })] }));
}
//# sourceMappingURL=overflow-menu.js.map